import api from "@/api/api-v1-config";

export async function getModuleAxios() {    
    return await api.get("module");
}

